/**
 * @generated SignedSource<<dedde8eceb5ed2c8338eee2f739763bc>>
 * @relayHash 4aac9d717d6aa95cb2190f2901efbdd3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a05a876c5b6689183776d17a141c77b3e2f1c06bff28d374f8cbef6e1a4aa9a6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkItemEntrypointUiQuery } from './WorkItemEntrypointUiQuery.graphql';

const node: PreloadableConcreteRequest<WorkItemEntrypointUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a05a876c5b6689183776d17a141c77b3e2f1c06bff28d374f8cbef6e1a4aa9a6",
    "metadata": {},
    "name": "WorkItemEntrypointUiQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
